var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen },
    },
    [
      _c(
        "div",
        { staticClass: "nav-header d-flex" },
        [
          _c(
            "div",
            {
              staticClass: "btn-close d-flex",
              on: {
                click: function ($event) {
                  return _vm.closeNavigation()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "18.286",
                    height: "19.232",
                    viewBox: "0 0 18.286 19.232",
                  },
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Icon",
                        transform: "translate(1.143 1.616)",
                      },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          id: "Area",
                          width: "16",
                          height: "16",
                          transform: "translate(0.001 0)",
                          fill: "#fcfcfc",
                          opacity: "0",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "g",
                        { attrs: { id: "Icon-2", "data-name": "Icon" } },
                        [
                          _c("line", {
                            attrs: {
                              id: "dc5b8dca-93dc-4323-8a91-2653592a474c",
                              x1: "16",
                              transform: "translate(0 8)",
                              fill: "none",
                              stroke: "#697578",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2.286",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              id: "ca26a024-ae3a-4c86-903b-83a925234c9f",
                              d: "M13.714,21.714l-8-8,8-8",
                              transform: "translate(-5.714 -5.714)",
                              fill: "none",
                              stroke: "#697578",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2.286",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._t("logo-block"),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized",
            },
          ],
          staticClass: "nav-container d-flex",
        },
        [
          _c(
            "div",
            {
              staticClass: "mainmenu w-100 p-0 m-0 menu-active accordion",
              attrs: { id: "accordionMenu" },
            },
            _vm._l(_vm.dataContainer1.categories, function (category, index) {
              return _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  {
                    staticClass: "card-header",
                    attrs: { id: "heading" + index },
                  },
                  [
                    _c("a", { attrs: { href: _vm.getCategoryUrl(category) } }, [
                      _vm._v(_vm._s(category.details[0].name)),
                    ]),
                    _vm._v(" "),
                    category.children && category.children.length
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-toggle collapsed",
                            attrs: {
                              type: "button",
                              "data-toggle": "collapse",
                              "data-target": "#menuCollapse" + index,
                              "aria-expanded": "false",
                              "aria-controls": "menuCollapse" + index,
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "icon-plus",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "27",
                                  height: "27",
                                  viewBox: "0 0 27 27",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    id: "Combined_Shape",
                                    "data-name": "Combined Shape",
                                    d: "M12.15,27V14.85H0v-2.7H12.15V0h2.7V12.15H27v2.7H14.85V27Z",
                                    fill: "#312527",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "svg",
                              {
                                staticClass: "icon-minus",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "27",
                                  height: "27",
                                  viewBox: "0 0 27 3",
                                },
                              },
                              [
                                _c("rect", {
                                  attrs: {
                                    id: "Rectangle_7",
                                    "data-name": "Rectangle 7",
                                    width: "3",
                                    height: "27",
                                    transform: "translate(0 3) rotate(-90)",
                                    fill: "#312527",
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                category.children && category.children.length
                  ? _c(
                      "div",
                      {
                        staticClass: "collapse position-relative",
                        attrs: {
                          id: "menuCollapse" + index,
                          "aria-labelledby": "heading" + index,
                          "data-parent": "#accordionMenu",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          [
                            _c("div", { staticClass: "triangle-down" }),
                            _vm._v(" "),
                            _vm.menuData &&
                            _vm.menuData[index] &&
                            _vm.menuData[index].customImageBoxPath
                              ? _c("lazy-img", {
                                  staticClass: "pic-cover",
                                  attrs: {
                                    "picture-class":
                                      "nav-image d-block full-abs",
                                    "image-url":
                                      _vm.menuData[index].customImageBoxPath,
                                    alt: _vm.menuData[index].altText,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.menuData &&
                            _vm.menuData[index] &&
                            _vm.menuData[index].customImageBoxPath
                              ? _c("div", { staticClass: "img-shadow" })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "ul",
                              {
                                staticClass: "menu-children w-100 p-0 m-0",
                                class: {
                                  "c-image":
                                    _vm.menuData &&
                                    _vm.menuData[index] &&
                                    _vm.menuData[index].customImageBoxPath,
                                },
                              },
                              _vm._l(category.children, function (child) {
                                return _c("li", {}, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.getCategoryUrl(
                                          category,
                                          child
                                        ),
                                      },
                                    },
                                    [_vm._v(_vm._s(child.details[0].name))]
                                  ),
                                  _vm._v(" "),
                                  child.children && child.children.length
                                    ? _c(
                                        "ul",
                                        { staticClass: "sub-menu-children" },
                                        _vm._l(
                                          child.children,
                                          function (subChild) {
                                            return _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: _vm.getCategoryUrl(
                                                      category,
                                                      child,
                                                      subChild
                                                    ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      subChild.details[0].name
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ])
                              }),
                              0
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nav-footer d-flex" },
        [
          _c(
            "client-only",
            [
              _c(
                "user-login-handler",
                {
                  attrs: {
                    "small-style": true,
                    "show-registration": false,
                    "show-simple": true,
                  },
                  on: {
                    "close-menu": function ($event) {
                      return _vm.closeNavigation()
                    },
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        "data-toggle": "modal",
                        "aria-label": _vm.$translate("Ceres::Template.login"),
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-user mr-0 mr-sm-1",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-none d-sm-inline" }, [
                        _vm._v(_vm._s(_vm.$translate("Ceres::Template.login"))),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c("ul", { staticClass: "breadcrumb" }, [
              _c("li", {
                staticClass: "btn-close",
                on: {
                  click: function ($event) {
                    return _vm.closeNavigation()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(0),
            ]),
            _vm._v(" "),
            _c("loading-animation"),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("i", { staticClass: "fa fa-home", attrs: { "aria-hidden": "true" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }